import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListComponent} from './list/list.component';
import {RouterModule, Routes} from '@angular/router';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectModule} from '@angular/material/select';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {RedirectComponent} from './redirect/redirect.component';
import {AddComponent} from './popup/add/add.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DetailComponent} from './detail/detail.component';
import {tabs} from '@models/tab';
import {AdModule} from '@components/ad/ad.module';
import {WidgetModule} from '@components/widget/widget.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSliderModule} from '@angular/material/slider';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {DetailWrapComponent} from './detail/detail-wrap/detail-wrap.component';
import {Nl2BrPipeModule} from 'nl2br-pipe';
import {NgxEchartsModule} from 'ngx-echarts';
import {CompareComponent} from './compare/compare.component';
import {DuplicateComponent} from './popup/duplicate/duplicate.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {AddCompareComponent} from './popup/add-compare/add-compare.component';
import {MessagesModule} from '@components/messages/messages.module';
import {FavoriteModule} from '@components/favorite/favorite.module';
import {PdfComponent} from './pdf/pdf.component';
import { OpenAdComponent } from './open-ad/open-ad.component';
import { OikosComponent } from './pdf/oikos/oikos.component';
import {JoyrideModule} from 'ngx-joyride';
import { JoustComponent } from './pdf/joust/joust.component';
import { IzimmoComponent } from './pdf/izimmo/izimmo.component';
import { PurpleComponent } from './pdf/purple/purple.component';
import { SharePopupComponent } from './list/share-popup/share-popup.component';
import {RenamePopupComponent} from '@module/favorites/list/rename-popup/rename-popup.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { NewPopupComponent } from './list/new-popup/new-popup.component';
import { NotesComponent } from './popup/notes/notes.component';
import { OrderListPopupComponent } from './list/order-list-popup/order-list-popup.component';
import { RenameComponent } from './popup/rename/rename.component';
import { MinutaComponent } from './pdf/minuta/minuta.component';

export const FavoriteRoutes: Routes = [
    {path: '', component: RedirectComponent},
    {path: 'open/:id', component: OpenAdComponent},
    {path: 'compare', component: CompareComponent},
    {path: ':id', component: ListComponent},
    {path: ':id/:favoriteId', redirectTo: ':id/:favoriteId/' + tabs[0].slug, pathMatch: 'full'},
    { // Private
        path: ':id/:favoriteId',
        component: DetailWrapComponent,
        children: [
            {
                path: 'pdf/joust',
                component: JoustComponent,
            },{
                path: 'pdf/oikos',
                component: OikosComponent,
            },{
                path: 'pdf/izimmo',
                component: IzimmoComponent,
            },{
                path: 'pdf/purple',
                component: PurpleComponent,
            },{
                path: 'pdf/minuta',
                component: MinutaComponent,
            },{
                path: 'pdf/:config',
                component: PdfComponent,
            }, {
                path: 'pdf/:config/edit', redirectTo: 'pdf/:config',
            }
        ],
        data: {tabs, edit: false}
    },
];

tabs.forEach(tab => {
    FavoriteRoutes[5].children.push({
        path: tab.slug,
        component: DetailComponent,
        data: {tab, edit: false}
    });
    FavoriteRoutes[5].children.push({
        path: tab.slug + '/edit',
        component: DetailComponent,
        data: {tab, edit: true}
    });
});

@NgModule({
    declarations: [
        ListComponent,
        RedirectComponent,
        AddComponent,
        DetailComponent,
        RenamePopupComponent,
        DetailWrapComponent,
        CompareComponent,
        DuplicateComponent,
        AddCompareComponent,
        PdfComponent,
        OpenAdComponent,
        OikosComponent,
        JoustComponent,
        IzimmoComponent,
        PurpleComponent,
        SharePopupComponent,
        NewPopupComponent,
        NotesComponent,
        OrderListPopupComponent,
        RenameComponent,
        MinutaComponent,
    ],
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        RouterModule.forChild(FavoriteRoutes),
        MatFormFieldModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        AdModule,
        WidgetModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatButtonToggleModule,
        DragDropModule,
        MatButtonModule,
        MatTooltipModule,
        MatSliderModule,
        NgxSliderModule,
        Nl2BrPipeModule,
        NgxEchartsModule,
        MatSlideToggleModule,
        MessagesModule,
        FavoriteModule,
        JoyrideModule,
        MatCheckboxModule,
    ]
})
export class FavoritesModule {
}
